// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/rawSpread/RawSpread.scss
// module id = 2268
// module chunks = 0